import { Box, Button, Checkbox, Container, FormControl, Grid, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, Paper, Backdrop, CircularProgress, Snackbar, Alert, Select, TextField, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../Constants";
import { axiosClient } from "../AxiosClient";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    color: '#FFFFFF',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    }
});

const versions = ["V1", "V2"];

const sectorComercio = ["Bicicletas", "Construccion", "Bicicletas", "Construccion", "Bicicletas", "Construccion"];

const urlApi = API_URL;

export default function PolicySegmentation() {
    const [segmentations, setSegmentations] = useState([
      {
        title: "Sectores comercios",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Regiones",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Ocupación",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Sectores ocupación cliente",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Comercios",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Rango ingresos",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Rango edades",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Tipo de cliente",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
      {
        title: "Genero",
        optionsLeft: [{ name: "", id: "" }],
        optionsRight: [],
        checkedLeft: [],
        checkedRight: [],
      },
    ]);
    const [version, setVersion] = useState(versions[0]);
    const [policies, setPolicies] = useState([]);
    const [policy, setPolicy] = useState();
    const [idPolicy, setIdPolicy] = useState();
    const [values, setValues] = useState([]);
    const [value, setValue] = useState();
    const [sectores, setSectores] = useState([]);
    const [backdrop, setBackdrop] = useState(false);
    const [alerta, setAlerta] = useState();
    const [snackBar, setSnackbar] = useState(false);
    const [severity, setSeverity] = useState();


    const handleAllRight = (index) => {
        segmentations[index].optionsRight = segmentations[index].optionsRight.concat(segmentations[index].optionsLeft).sort();
        segmentations[index].optionsLeft = [];
        setSegmentations([...segmentations]);
    }
    
    const handleAllLeft = (index) => {
        segmentations[index].optionsLeft = segmentations[index].optionsLeft.concat(segmentations[index].optionsRight).sort();
        segmentations[index].optionsRight = [];
        setSegmentations([...segmentations]);
    }

    const handleToggle = (value, index) => {
        if(segmentations[index].optionsRight.indexOf(value) !== -1) {
            const position = segmentations[index].checkedRight.indexOf(value)
            if(position === -1) {
                segmentations[index].checkedRight.push(value);
            } else {
                segmentations[index].checkedRight.splice(position,1);
            }
        } else {
            const position = segmentations[index].checkedLeft.indexOf(value)
            if(position === -1) {
                segmentations[index].checkedLeft.push(value);
            } else {
                segmentations[index].checkedLeft.splice(position,1);
            }
        }
        setSegmentations([...segmentations])
    }

    console.log(segmentations[0])
    console.log("Hello")

    const handleCheckLeft = (index) => {
        segmentations[index].optionsLeft = segmentations[index].optionsLeft.concat(segmentations[index].checkedRight).sort();
        segmentations[index].optionsRight = segmentations[index].optionsRight.filter(segmentation => segmentations[index].checkedRight.indexOf(segmentation) === -1);
        segmentations[index].checkedRight = [];
        setSegmentations([...segmentations]);
    }

    const handleCheckRight = (index) => {
        segmentations[index].optionsRight = segmentations[index].optionsRight.concat(segmentations[index].checkedLeft).sort();
        segmentations[index].optionsLeft = segmentations[index].optionsLeft.filter(segmentation => segmentations[index].checkedLeft.indexOf(segmentation) === -1);
        segmentations[index].checkedLeft = [];
        setSegmentations([...segmentations]);
    }

    const handleVersion = (event) => {
        setVersion(event.target.value);
        updateSegmentations(sectores);
    }

    const handlePolicy = (event) => {
        setPolicy(event.target.value);
        axiosClient.get(`/v1/policies-segmentation/policy/${event.target.value}`)
        .then(response => {
            if (response.status === 200) {
                setValues(response.data);
                console.log(response.data.map(value => (value.segmentation.split("/"))));
            } else {
                console.log("Error petition");
            }
        })
        .catch(error => {
            console.log("Error fetch: " + error.message);
        });
    }

    const handleSegmentation = (event) => {
        const segmentation = event.target.value.segmentation.split('-&-');
        console.log(event.target.value)
        console.log(segmentation)
        segmentation.pop();
        if(segmentation[0] !== "") {
            const opciones = segmentation[0].split('-*-');
            segmentations[0].optionsLeft = sectores?.sectoresComercios?.filter(sectorComercio => !opciones.includes(sectorComercio?.name))?.map(sectorComercio => ({name: sectorComercio?.name, id: sectorComercio?.uuid}));
            segmentations[0].optionsRight = sectores?.sectoresComercios?.filter(sectorComercio => opciones.includes(sectorComercio?.name))?.map(sectorComercio => ({name: sectorComercio?.name, id: sectorComercio?.uuid}));
        }
        if(segmentation[1] !== "") {
            const opciones = segmentation[1].split('-*-');
            segmentations[1].optionsLeft = sectores?.regiones?.filter(region => !opciones.includes(region?.name))?.map(region => ({name: region?.name, id: region?.uuid}));
            segmentations[1].optionsRight = sectores?.regiones?.filter(region => opciones.includes(region?.name))?.map(region => ({name: region?.name, id: region?.uuid}));
        }
        if(segmentation[2] !== "") {
            const opciones = segmentation[2].split('-*-');
            segmentations[2].optionsLeft = sectores?.ocupaciones?.filter(ocupacion => !opciones.includes(ocupacion?.name))?.map(ocupacion => ({name: ocupacion?.name, id: ocupacion?.uuid}));
            segmentations[2].optionsRight = sectores?.ocupaciones?.filter(ocupacion => opciones.includes(ocupacion?.name))?.map(ocupacion => ({name: ocupacion?.name, id: ocupacion?.uuid}));
        }
        if(segmentation[3] !== "") {
            const opciones = segmentation[3].split('-*-');
            segmentations[3].optionsLeft = sectores?.sectoresOcupacion?.filter(sectorOcupacion => !opciones.includes(sectorOcupacion?.name))?.map(sectorOcupacion => ({name: sectorOcupacion?.name, id: sectorOcupacion?.uuid}));
            segmentations[3].optionsRight = sectores?.sectoresOcupacion?.filter(sectorOcupacion => opciones.includes(sectorOcupacion?.name))?.map(sectorOcupacion => ({name: sectorOcupacion?.name, id: sectorOcupacion?.uuid}));
        }
        if(segmentation[4] !== "") {
            const opciones = segmentation[4].split('-*-');
            segmentations[4].optionsLeft = sectores?.comercios?.filter(comercio => !opciones.includes(comercio?.name))?.map(comercio => ({name: comercio?.name, id: comercio?.uuid}));
            segmentations[4].optionsRight = sectores?.comercios?.filter(comercio => opciones.includes(comercio?.name))?.map(comercio => ({name: comercio?.name, id: comercio?.uuid}));
        }
        if(segmentation[5] !== "") {
            const opciones = segmentation[5].split('-*-');
            segmentations[5].optionsLeft = sectores?.rangosIngresos?.filter(rangoIngresos => !opciones.includes(rangoIngresos?.range))?.map(rangoIngresos => ({name: rangoIngresos?.range, id: rangoIngresos?.uuid}));
            segmentations[5].optionsRight = sectores?.rangosIngresos?.filter(rangoIngresos => opciones.includes(rangoIngresos?.range))?.map(rangoIngresos => ({name: rangoIngresos?.range, id: rangoIngresos?.uuid}));
        }
        if(segmentation[6] !== "") {
            const opciones = segmentation[6].split('-*-');
            segmentations[6].optionsLeft = sectores?.rangosEdades?.filter(rangoEdades => !opciones.includes(rangoEdades?.range))?.map(rangoEdades => ({name: rangoEdades?.range, id: rangoEdades?.uuid}));
            segmentations[6].optionsRight = sectores?.rangosEdades?.filter(rangoEdades => opciones.includes(rangoEdades?.range))?.map(rangoEdades => ({name: rangoEdades?.range, id: rangoEdades?.uuid}));
        }
        if(segmentation[7] !== "") {
            const opciones = segmentation[7].split('-*-');
            segmentations[7].optionsLeft = sectores?.tiposCliente?.filter(tipoCliente => !opciones.includes(tipoCliente?.type))?.map(tipoCliente => ({name: tipoCliente?.type, id: tipoCliente?.uuid}));
            segmentations[7].optionsRight = sectores?.tiposCliente?.filter(tipoCliente => opciones.includes(tipoCliente?.type))?.map(tipoCliente => ({name: tipoCliente?.type, id: tipoCliente?.uuid}));
        }
        if(segmentation[8] !== "") {
            const opciones = segmentation[8].split('-*-');
            segmentations[8].optionsLeft = sectores?.generos?.filter(genero => !opciones.includes(genero?.name))?.map(genero => ({name: genero?.name, id: genero?.uuid}));
            segmentations[8].optionsRight = sectores?.generos?.filter(genero => opciones.includes(genero?.name))?.map(genero => ({name: genero?.name, id: genero?.uuid}));
        }
        setValue(event.target.value);
        setSegmentations([...segmentations]);
    }

    const handleSnackbar = () => {
        setSnackbar(false);
    }

    const generateTexts = (string) => {
        let texts = string.split("-&-");
        let asignacion = "";
        texts.pop();
        return texts.filter(items => items !== "").join('-&-');
    }

    const updateSegmentations = (datos) => {
        console.log(datos);
        segmentations[0].optionsLeft = datos?.sectoresComercios?.map(sectorComercio => ({name: sectorComercio?.name, id: sectorComercio?.uuid}));
        segmentations[0].optionsRight = [];
        segmentations[1].optionsLeft = datos?.regiones?.map(region => ({name: region?.name, id: region?.uuid}));
        segmentations[1].optionsRight = [];
        segmentations[2].optionsLeft = datos?.ocupaciones?.map(ocupacion => ({name: ocupacion?.name, id: ocupacion?.uuid}));
        segmentations[2].optionsRight = [];
        segmentations[3].optionsLeft = datos?.sectoresOcupacion?.map(sectorOcupacion => ({name: sectorOcupacion?.name, id: sectorOcupacion?.uuid}));
        segmentations[3].optionsRight = [];
        segmentations[4].optionsLeft = datos?.comercios?.map(comercio => ({name: comercio?.name, id: comercio?.uuid}));
        segmentations[4].optionsRight = [];
        segmentations[5].optionsLeft = datos?.rangosIngresos?.map(rangoIngresos => ({name: rangoIngresos?.range, id: rangoIngresos?.uuid}));
        segmentations[5].optionsRight = [];
        segmentations[6].optionsLeft = datos?.rangosEdades?.map(rangoEdades => ({name: rangoEdades?.range, id: rangoEdades?.uuid}));
        segmentations[6].optionsRight = [];
        segmentations[7].optionsLeft = datos?.tiposCliente?.map(tipoCliente => ({name: tipoCliente?.type, id: tipoCliente?.uuid}));
        segmentations[7].optionsRight = [];
        segmentations[8].optionsLeft = datos?.generos?.map(genero => ({name: genero?.name, id: genero?.uuid}));
        segmentations[8].optionsRight = []; 
        setSegmentations([...segmentations]);
    }


    const handleGenerate = () => {
        const sectoresComercios = segmentations.filter(segmentation => segmentation.title == "Sectores comercios")[0]?.optionsRight.map(items => items.id);
        const regiones = segmentations.filter(segmentation => segmentation.title == "Regiones")[0]?.optionsRight.map(items => items.id);
        const ocupacion = segmentations.filter(segmentation => segmentation.title == "Ocupación")[0]?.optionsRight.map(items => items.id);
        const sectoresOcupacion = segmentations.filter(segmentation => segmentation.title == "Sectores ocupación cliente")[0]?.optionsRight.map(items => items.id);
        const comercios = segmentations.filter(segmentation => segmentation.title == "Comercios")[0]?.optionsRight.map(items => items.id);
        const rangosIngresos = segmentations.filter(segmentation => segmentation.title == "Rango ingresos")[0]?.optionsRight.map(items => items.id);
        const rangosEdades = segmentations.filter(segmentation => segmentation.title == "Rango edades")[0]?.optionsRight.map(items => items.id);
        const tiposCliente = segmentations.filter(segmentation => segmentation.title == "Tipo de cliente")[0]?.optionsRight.map(items => items.id);
        const generos = segmentations.filter(segmentation => segmentation.title == "Genero")[0]?.optionsRight.map(items => items.id);
        if(segmentations.filter(items => items.optionsRight.length > 0)?.length > 0) {
            if(policy && policy != "") {
                setBackdrop(true);
                axiosClient
                  .post(`/v1/policies-segmentation/segmentations/${policy}`, {
                    sectoresComercios: sectoresComercios,
                    regiones: regiones,
                    ocupaciones: ocupacion,
                    sectoresOcupacion: sectoresOcupacion,
                    comercios: comercios,
                    rangosIngresos: rangosIngresos,
                    rangosEdades: rangosEdades,
                    tiposCliente: tiposCliente,
                    generos: generos,
                  })
                  .then((response) => {
                    if (response.status === 200) {
                      if (version === versions[0]) {
                        setVersion(versions[1]);
                      } else {
                        setVersion(versions[0]);
                      }
                      segmentations.forEach((items, indexSegmentation) =>
                        handleAllLeft(indexSegmentation),
                      );
                      setBackdrop(false);
                      setValue("");
                      setSnackbar(true);
                      setAlerta(
                        "Se creó exitosamente la política de asignación",
                      );
                      setSeverity("success");
                    } else {
                      console.log("Error petition");
                      setBackdrop(false);
                      setSnackbar(true);
                      setAlerta(
                        "Ocurrió un error en la creación de la asignación",
                      );
                      setSeverity("error");
                    }
                  })
                  .catch((error) => {
                    console.log("Error fetch " + error.message);
                    setBackdrop(false);
                    setSnackbar(true);
                    setAlerta(
                      "Ocurrió un error en la creación de la asignación",
                    );
                    setSeverity("error");
                  });
            } else {
                setSnackbar(true);
                setAlerta("Debes seleccionar una opción de politica");
                setSeverity("error");
            }
        } else {
            setSnackbar(true);
            setAlerta("Debes seleccionar almenos una opción para guardar");
            setSeverity("error");
        }
    }

    const handleUpdate = () => {
        const sectoresComercios = segmentations.filter(segmentation => segmentation.title == "Sectores comercios")[0]?.optionsRight.map(items => items.id);
        const regiones = segmentations.filter(segmentation => segmentation.title == "Regiones")[0]?.optionsRight.map(items => items.id);
        const ocupacion = segmentations.filter(segmentation => segmentation.title == "Ocupación")[0]?.optionsRight.map(items => items.id);
        const sectoresOcupacion = segmentations.filter(segmentation => segmentation.title == "Sectores ocupación cliente")[0]?.optionsRight.map(items => items.id);
        const comercios = segmentations.filter(segmentation => segmentation.title == "Comercios")[0]?.optionsRight.map(items => items.id);
        const rangosIngresos = segmentations.filter(segmentation => segmentation.title == "Rango ingresos")[0]?.optionsRight.map(items => items.id);
        const rangosEdades = segmentations.filter(segmentation => segmentation.title == "Rango edades")[0]?.optionsRight.map(items => items.id);
        const tiposCliente = segmentations.filter(segmentation => segmentation.title == "Tipo de cliente")[0]?.optionsRight.map(items => items.id);
        const generos = segmentations.filter(segmentation => segmentation.title == "Genero")[0]?.optionsRight.map(items => items.id);
        if(segmentations.filter(items => items.optionsRight.length > 0)?.length > 0) {
            if(value?.idAsignacion) {
                setBackdrop(true);
                axiosClient.patch(`/v1/policies-segmentation/${policy}/${value?.idAsignacion}`, {
                    sectoresComercios: sectoresComercios,
                    regiones: regiones,
                    ocupaciones: ocupacion,
                    sectoresOcupacion: sectoresOcupacion,
                    comercios: comercios,
                    rangosIngresos: rangosIngresos,
                    rangosEdades: rangosEdades,
                    tiposCliente: tiposCliente,
                    generos: generos
                })
                .then(response => {
                    if (response.status === 200) {
                        if (version === versions[0]) {
                            setVersion(versions[1]);
                        } else {
                            setVersion(versions[0]);
                        }
                        segmentations.forEach((items, indexSegmentation) => handleAllLeft(indexSegmentation));
                        setValue("");
                        setBackdrop(false);
                        setSnackbar(true);
                        setAlerta("Se actualizó exitosamente la política de asignación");
                        setSeverity("success");
                    } else {
                        console.log("Error petition");
                        setBackdrop(false);
                        setSnackbar(true);
                        setAlerta("Ocurrió un error en la actualización de la asignación");
                        setSeverity("error");
                    }
                })
                .catch(error => {
                    console.log("Error fetch " + error.message);
                    setBackdrop(false);
                    setSnackbar(true);
                    setAlerta("Ocurrió un error en la actualización de la asignación");
                    setSeverity("error");
                });
            } else {
                setSnackbar(true);
                setAlerta("Debes seleccionar una opción de asignación");
                setSeverity("error");
            }
        } else {
            setSnackbar(true);
                setAlerta("Debes seleccionar almenos una opción para actualizar");
                setSeverity("error");
        }
    }

    const deleteSegmentation = () => {
        if(value?.idAsignacion) {
            setBackdrop(true);
            axiosClient.delete(`/v1/policies-segmentation/${value?.idAsignacion}`)
            .then(response => {
                if (response.status === 200) {
                    if (version === versions[0]) {
                        setVersion(versions[1]);
                    } else {
                        setVersion(versions[0]);
                    }
                    segmentations.forEach((items, indexSegmentation) => handleAllLeft(indexSegmentation));
                    setValue("");
                    setBackdrop(false);
                    setSnackbar(true);
                    setAlerta("Se eliminó exitosamente la política de asignación");
                    setSeverity("success");
                } else {
                    console.log("Error petition");
                    setBackdrop(false);
                    setSnackbar(true);
                    setAlerta("Ocurrió un error en la eliminación de la asignación");
                    setSeverity("error");
                }
            })
            .catch(error => {
                console.log("Error fetch " + error.message);
                setBackdrop(false);
                setSnackbar(true);
                setAlerta("Ocurrió un error en la eliminación de la asignación");
                setSeverity("error");
            });
        } else {
            setSnackbar(true);
            setAlerta("Debes seleccionar una opción de asignación");
            setSeverity("error");
        }
    }

    useEffect(() => {
        setValues([]);
        axiosClient.get(`/v1/policies/${version}`)
        .then(response => {
            if (response.status === 200) {
                setPolicies(response.data.map(policy => policy.policy));
                setPolicy();
            } else {
                console.log("Error fetch");
            }
        })
        .catch(error => {
            console.log("Bad fetch " + error.message);
        });
    }, [version])

    useEffect(() => {
        axiosClient.get('/v1/policies-segmentation')
        .then(response => {
            if (response.status === 200) {
                const items = response.data;
                console.log(items);
                setSectores(items);
                segmentations[0].optionsLeft = items?.sectoresComercios?.map(sectorComercio => ({ name: sectorComercio?.name, id: sectorComercio?.uuid }));
                segmentations[1].optionsLeft = items?.regiones?.map(region => ({ name: region?.name, id: region?.uuid }));
                segmentations[2].optionsLeft = items?.ocupaciones?.map(ocupacion => ({ name: ocupacion?.name, id: ocupacion?.uuid }));
                segmentations[3].optionsLeft = items?.sectoresOcupacion?.map(sectorOcupacion => ({ name: sectorOcupacion?.name, id: sectorOcupacion?.uuid }));
                segmentations[4].optionsLeft = items?.comercios?.map(comercio => ({ name: comercio?.name, id: comercio?.uuid }));
                segmentations[5].optionsLeft = items?.rangosIngresos?.map(rangoIngresos => ({ name: rangoIngresos?.range, id: rangoIngresos?.uuid }));
                segmentations[6].optionsLeft = items?.rangosEdades?.map(rangoEdades => ({ name: rangoEdades?.range, id: rangoEdades?.uuid }));
                segmentations[7].optionsLeft = items?.tiposCliente?.map(tipoCliente => ({ name: tipoCliente?.type, id: tipoCliente?.uuid }));
                segmentations[8].optionsLeft = items?.generos?.map(genero => ({ name: genero?.name, id: genero?.uuid }));
                setSegmentations([...segmentations]);
            } else {
                console.log("Error fetch");
            }
        })
        .catch(error => {
            console.log("Bad fetch " + error.message);
        });
    }, [])

    console.log(segmentations)
    console.log(sectores)
    console.log(values)

    return (
        <React.Fragment>
            <br></br>
            <Box sx={{width: '100%', marginTop: '1.9rem', marginBottom: '1rem'}}>
                <Container>
                    <Item></Item>
                    <Item>.</Item>
                    <Grid container marginTop={2}>
                        <h1>Asignación políticas</h1>
                        <Box sx={{width: '50vw', padding: '1rem', display: 'flex', gap: '1rem'}}>
                            <ButtonPrincipal onClick={handleGenerate}>Crear</ButtonPrincipal>
                            <ButtonPrincipal onClick={handleUpdate}>Modificar</ButtonPrincipal>
                            <ButtonPrincipal onClick={deleteSegmentation}>Eliminar</ButtonPrincipal>
                        </Box>
                        <Grid sx={{width: '100%'}} marginTop={2}>
                            <Box sx={{display: 'flex', gap: '1rem'}}>
                                <FormControl fullWidth>
                                    <InputLabel id="version">Versión política</InputLabel>
                                    <Select labelId="version" id="version-select" label="Versión política" value={version} onChange={handleVersion}>
                                        {versions.map(items => (
                                            <MenuItem key={items} value={items}>{items}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth>
                                    <InputLabel id="politica">Política</InputLabel>
                                    <Select labelId="politica" id="politica-select" label="Política" value={policy} onChange={handlePolicy}>
                                        {policies.map(items => (
                                            <MenuItem key={items?.name} value={items?.uuid}>{items?.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="segmentaion">Asignaciones</InputLabel>
                                    <Select labelId="segmentation" id="nombre" label="Asignaciones" value={value} onChange={handleSegmentation}>
                                        {values?.map(items => (
                                            <MenuItem key={items?.segmentation} value={items}>{generateTexts(items?.segmentation)}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            {segmentations.map((segmentation,indexSegmentation) => (
                                <Box key={segmentation.title + indexSegmentation}>
                                    <h2>{segmentation.title}</h2>
                                    <Box sx={{border: '1px solid #161e55', overflow: 'auto', borderRadius: '1rem'}} mt={2}>
                                        <Grid container justifyContent={'space-around'}>
                                            <Grid container width={'18%'} alignItems={'center'}>
                                                <List dense component={"div"} role="list">
                                                    {segmentation.optionsLeft?.map((items,index) => (
                                                        <ListItemButton
                                                            key={items.name}
                                                            role="listitem"
                                                            onClick={() => handleToggle(items, indexSegmentation)}
                                                        >
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    inputProps={{
                                                                        'aria-labelledby': index
                                                                    }}
                                                                ></Checkbox>
                                                            </ListItemIcon>
                                                            <ListItemText id={index} primary={items.name}></ListItemText>
                                                        </ListItemButton>
                                                    ))}
                                                </List>
                                            </Grid>
                                            <Grid item borderRight={'1px solid #161e55'} borderLeft={'1px solid #161e55'}>
                                                <Grid container direction='column' padding='1rem' alignItems={'center'} sx={{height: '100%', justifyContent: 'center'}}>
                                                    <ButtonPrincipal sx={{marginTop: '0.5rem', ":disabled": {opacity: "0.5", color: "gray"}}} disabled={segmentation.optionsLeft?.length === 0} onClick={() => handleAllRight(indexSegmentation)}>{">>"}</ButtonPrincipal>
                                                    <ButtonPrincipal sx={{marginTop: '0.5rem', ":disabled": {opacity: '0.5', color: "gray"}}} disabled={segmentation.optionsLeft?.length === 0} onClick={() => handleCheckRight(indexSegmentation)}>{">"}</ButtonPrincipal>
                                                    <ButtonPrincipal sx={{marginTop: '0.5rem', ":disabled": {opacity: '0.5', color: 'gray'}}} disabled={segmentation.optionsRight?.length === 0} onClick={() => handleAllLeft(indexSegmentation)}>{"<<"}</ButtonPrincipal>
                                                    <ButtonPrincipal sx={{marginTop: '0.5rem', ":disabled": {opacity: '0.5', color: 'gray'}}} disabled={segmentation.optionsRight?.length === 0} onClick={() => handleCheckLeft(indexSegmentation)}>{"<"}</ButtonPrincipal>
                                                </Grid>
                                            </Grid>
                                            <Grid container width={'18%'} alignItems={'center'}>
                                                <List dense component={"div"} role="list">
                                                    {segmentation.optionsRight?.map((items,index) => (
                                                        <ListItemButton
                                                            key={items?.name}
                                                            role="listitem"
                                                            onClick={() => handleToggle(items, indexSegmentation)}
                                                        >
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    inputProps={{
                                                                        'aria-labelledby': index
                                                                    }}
                                                                ></Checkbox>
                                                            </ListItemIcon>
                                                            <ListItemText id={index} primary={items?.name}></ListItemText>
                                                        </ListItemButton>
                                                    ))}
                                                </List>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            ))
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={backdrop}>
                <CircularProgress color="success"/>
            </Backdrop>
            <Snackbar open={snackBar} autoHideDuration={5000} onClose={handleSnackbar}>
                <Alert onClose={handleSnackbar} severity={severity} sx={{width: '100%'}}>{alerta}</Alert>
            </Snackbar>
        </React.Fragment>
    )
}